<template>
  <div class="newwarp boxsizing miniwarp">
    <el-progress class="progress" :text-inside="true" :show-text="false" :stroke-width="2" :percentage="progress"></el-progress>
    <div class="auto">
      <page-title title="概览" icon="fa-clock-o"></page-title>
    </div>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div class="padding-15">
          <dufault-column title="" height="auto" v-loading="loading">
            <div slot="content">
              <el-row :gutter="10" class="top-box">
                <el-col :span="8" class="height-100">
                  <p class="panel-title font26">
                    当前活跃用户
                    <el-tooltip class="item" effect="dark" content="" placement="top">
                      <div slot="content">
                        头部蓝色进度条单次运行时间为20秒，进度条完整运行一次数据即更新一次。<br/>
                        实时功能统计人数为当前账号30分钟内有过活跃行为的用户人数，分为公众号活跃、H5活跃及跳转链接活跃3种。
                      </div>
                      <i class="fa fa-question-circle-o gray80"></i>
                    </el-tooltip>
                  </p >
                  <div class="num-wrap">
                    <div class="numBox">
                      <p class="panel-num">{{trackNum + mpNum + linkNum}}</p >
                      <p class="num-unit">位</p >
                    </div>
                    <div class="panel-title-line">
                      <ul>
                        <li><i></i><span>公众号人数</span></li>
                        <li><i></i><span>H5浏览人数</span></li>
                        <li><i></i><span>跳转链接人数</span></li>
                      </ul>
                      <ol>
                        <li :style="{'flex-basis': + perPerson1 + '%'}">{{mpNum}}</li>
                        <li :style="{'flex-basis': + perPerson2 + '%'}">{{trackNum}}</li>
                        <li :style="{'flex-basis': + perPerson3 + '%'}">{{linkNum}}</li>
                      </ol>
                    </div>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="title-wrap-c">
                    <p class="title-c font18">当前浏览量</p >
                  </div>
                  <p class="title-c-sub">每分钟</p >
                  <div style="width:100%; height:300px;">
                    <echarts :data="chartData" height="280" :nohader="true"></echarts>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="12">
        <div v-if="$store.state.user !== '' && String($store.state.user.service_type_info['id']) === '2'">
          <dufault-column title="活跃用户二维码来源 top5 " tooltip="活跃用户二维码来源Top5，当前账号30分钟内，活跃用户二维码来源及活跃人数。" :nomargin="true" height="auto" v-loading="tableLoading">
            <div slot="content">
              <div class="insidebox">
                <table-temp-new :tableHead="tableHead1" :tableData="tableData1"></table-temp-new>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="m-l-15">
          <dufault-column title="活跃用户点击菜单 top5 " tooltip="活跃用户点击菜单Top5，当前账号30分钟内，点击菜单的用户人数、次数。" :nomargin="true" height="auto" v-loading="tableLoading">
            <div slot="content">
              <div class="insidebox">
                <table-temp-new :tableHead="tableHead2" :tableData="tableData2"></table-temp-new>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="12">
        <div v-if="$store.state.user !== '' && String($store.state.user.service_type_info['id']) === '2'">
          <dufault-column title="活跃用户访问H5 top5 " tooltip="活跃用户访问的H5Top5，当前账号30分钟内，访问H5的用户人数、次数。" :nomargin="true" height="auto" v-loading="tableLoading">
            <div slot="content">
              <div class="insidebox">
                <table-temp-new :tableHead="tableHead3" :tableData="tableData3"></table-temp-new>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
      <el-col v-if="$store.state.user !== '' && String($store.state.user.service_type_info['id']) === '2'" :span="12">
        <div class="m-l-15">
          <dufault-column title="活跃用户点击跳转链接 top5 " tooltip="活跃用户点击跳转链接Top5，当前账号30分钟内，点击跳转链接的用户人数、次数。" :nomargin="true" height="auto" v-loading="tableLoading">
            <div slot="content">
              <div class="insidebox">
                <table-temp-new :tableHead="tableHead4" :tableData="tableData4"></table-temp-new>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// import { EchartsBase, TableTempNew } from '@/view/common'
import { Data as DataModel } from '@/model'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      progress: 0,
      timer: null,
      timeCounter: 45,
      loading: true,
      chartData: {},
      mpNum: 0,
      trackNum: 0,
      linkNum: 0,
      tableHead1: [
        {
          title: '来源',
          tag: 'name'
        },
        {
          title: '人数',
          tag: 'uni',
          sort: true,
          width: '100',
          thousand: true
        }
      ],
      tableData1: [],
      tableHead2: [
        {
          title: '菜单名称',
          tag: 'name'
        },
        {
          title: '人数',
          tag: 'uni',
          sort: true,
          width: '100',
          thousand: true
        },
        {
          title: '次数',
          tag: 'total',
          sort: true,
          width: '100',
          thousand: true
        }
      ],
      tableData2: [],
      tableHead3: [
        {
          title: 'H5名称'
        },
        {
          title: '人数',
          tag: 'uni',
          sort: true,
          width: '100',
          thousand: true
        },
        {
          title: '次数',
          tag: 'total',
          sort: true,
          width: '100',
          thousand: true
        }
      ],
      tableData3: [],
      tableHead4: [
        {
          title: '跳转链接'
        },
        {
          title: '人数',
          tag: 'uni',
          sort: true,
          width: '100',
          thousand: true
        },
        {
          title: '次数',
          tag: 'total',
          sort: true,
          width: '100',
          thousand: true
        }
      ],
      tableData4: []
    }
  },
  computed: {
    perPerson1: function () {
      var max = this.mpNum + this.trackNum + this.linkNum
      return this.mpNum / max * 100 - 0.3
    },
    perPerson2: function () {
      var max = this.mpNum + this.trackNum + this.linkNum
      return this.trackNum / max * 100
    },
    perPerson3: function () {
      var max = this.mpNum + this.trackNum + this.linkNum
      return this.linkNum / max * 100
    }
  },
  // components: {
  //   EchartsBase,
  //   TableTempNew
  // },
  methods: {
    async getOverviewChart () {
      this.loading = true
      let chartResult = await DataModel.RealTime.getOverviewChart()
      this.chartData = DataController.RealTime.overview(chartResult['data']['time_list'])
      this.trackNum = chartResult['data']['track_user'] || 0
      this.mpNum = chartResult['data']['mp_user'] || 0
      this.linkNum = chartResult['data']['link_user'] || 0
      this.loading = false
    },
    async summaryTable () {
      this.tableLoading = true
      let tableResult = await DataModel.RealTime.summaryTable()
      this.tableData1 = tableResult['data']['qr_scene'] || []
      this.tableData2 = tableResult['data']['menu'] || []
      this.tableData3 = tableResult['data']['H5'] || []
      this.tableData4 = tableResult['data']['rd'] || []
      this.tableLoading = false
    },
    getData () {
      this.getOverviewChart()
      this.summaryTable()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.timeCounter > 0) {
          if (this.progress === 100) {
            this.getData()
            this.progress = 0
            this.timeCounter--
          } else {
            this.progress = this.progress + 5
          }
        } else {
          this.$alert('自动刷新任务已暂停！', '提醒', {
            confirmButtonText: '确定',
            callback: action => {
              window.location.reload()
            }
          })
          clearInterval(this.timer)
        }
      }, 1000)
    }
  },
  created () {
    this.getData()
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.insidebox {
  padding: 0 30px;
}
.right-content{
  border:1px solid #eee;
}
.top-box{
  margin-top: 15px;
}
.bar-wrap{
  min-height: 350px;
  width: 100%;
  overflow-x: hidden;
}
.panel-title{
  color: #4a4a4a;
  text-align: center;
  line-height: 50px;
}
.panel-num{
  font-size: 94px;
  color: #409EFF;
  line-height: 200px;
  letter-spacing: -5px;
}
.num-unit{
  font-size: 30px;
  color: rgb(74,74,74);
  line-height: 160px;
  margin-left: 5px;
}
.num-wrap div.numBox{
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-top: 15px;
}
.title-c{
  line-height: 30px;
  color: #4a4a4a;
}
.title-wrap-c{
  border-bottom: 3px solid rgba(151, 151, 151, 1);
  padding-bottom: 5px;
}
.title-c-sub{
  font-size: 14px;
  line-height: 25px;
  color: #4a4a4a;
  margin-top: 5px;
}
.view-more{
  color: #003692!important;
  line-height: 50px;
  font-size: 12px;
}
.view-more a{
  color: #409EFF!important;
}

.panel-title-line{
  width: 84%;
  height: auto;
  clear: both;
  padding: 0 8%;
}
.panel-title-line ul{
  width: 100%;
  height: auto;
  overflow: hidden;
}
.panel-title-line ul li{
  float: left;
  margin-left: 10px;
}
.panel-title-line ul li i{
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #F15625;
  margin-right: 3px;
}
.panel-title-line ul li:nth-child(2) i{
  background: #48B540;
}
.panel-title-line ul li:nth-child(3) i{
  background: #3a79cc;
}
.panel-title-line ol{
  width: 100%;
  height: auto;
  margin-top: 5px;
  display: flex;
}
.panel-title-line ol li{
  flex: 1;
  float: left;
  text-align: center;
  background: #48B540;
  color: #fff;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  /*-webkit-box-reflect: below 1px -webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(0.5,rgba(255,255,255,0)),to(rgba(255,255,255,.3)));*/
  /*text-shadow: 0 1px 1px #000;*/
}
.panel-title-line ol li:nth-child(1){
  background: #F15625;
  border-radius: 3px 0 0 3px;
  float: left;
}
.panel-title-line ol li:nth-child(3){
  background: #3a79cc;
  border-radius: 0 3px 3px 0;
  /* float: right; */
}
.progress {
  position: fixed;
  width: calc(100% - 241px);
  top: 65px;
  left: 241px;
  z-index: 1;
}
</style>
